import { useQuery } from 'react-query';
import { getCommentDetail } from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetCommentDetail({
  adaptedFictionEditionId,
  commentId
}: {
  adaptedFictionEditionId: string;
  commentId: string;
}) {
  return useQuery({
    queryKey: SCENE_QUERY_KEYS.sceneCommentDetail(adaptedFictionEditionId, commentId),
    queryFn: () => getCommentDetail({ adaptedFictionEditionId, commentId }),
    enabled: !!adaptedFictionEditionId && !!commentId
  });
}
